<template lang="pug">
    v-form(ref="groupAccountForm" id="groupAccountForm" @submit.prevent="doSave" lazy-validation)
        v-container(grid-list-md)
            v-layout(wrap)
                v-flex(lg3 md3 xs12)
                    v-text-field(dense v-model="groupAccount.accountNumber" label="No. Rekening" readonly)
                v-flex(lg4 md4 xs12)
                    v-text-field(dense v-model="groupAccount.accountName" label="Atas Nama" readonly)
                v-flex(lg4 md4 xs12)
                    f-select-account-type(v-model="groupAccount.accountType" label="Jenis" readonly)
            v-layout(wrap)
                v-flex(lg4 md4 xs12)
                    v-switch(v-model="groupAccount.accessTransaction" label="Perbolehkan melakukan transaksi ?")
                v-flex(lg4 md4 xs12)
                    v-switch(v-model="groupAccount.mainAccount" label="Rekening utama ?")
            div(justify-center style="text-align: center" class="ma-2 menu-btn")
                v-btn(class="mx-1" @click="doCancel") Kembali
                    v-icon mdi-arrow-left
                v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="groupAccountForm") Simpan
                    v-icon mdi-content-save-outline
</template>
<script>
export default {
    name: "FGroupAccountForm",
    props: ["dataGroupAccount"],
    data() {
        return {
            groupAccount: {}
        }
    },
    watch: {
        dataGroupAccount(val){
            this.doInit(val);
        }
    },
    mounted() {
        this.doInit(this.dataGroupAccount);
        
    },
    methods: {
        doInit(values){
            this.groupAccount = values ? values : {};
            if (this.$refs.groupAccountForm) {
                this.$refs.groupAccountForm.resetValidation();
            }
        },
        doSave(){
            if (this.$refs.groupAccountForm.validate()) {
                this.$refs.groupAccountForm.resetValidation();
                this.$emit("groupAccount", this.groupAccount);
            }
        },
        doCancel(){
            this.$refs.groupAccountForm.resetValidation();
            this.$emit("cancel");
        }
    },
}
</script>